import { CheckCircle2, LogIn, UsersRound } from "lucide-react";
import { useState } from "react";
import { Link, useParams } from "react-router-dom";

import api from "../api/client";
import BrandMark from "../components/BrandMark";
import { ErrorNotice } from "../components/Feedback";
import Seo from "../components/Seo";
import { apiErrorMessage } from "../utils/apiError";

export default function TeamInviteAcceptPage() {
  const { token } = useParams();
  const [accepted, setAccepted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const acceptInvite = async () => {
    if (!token) return;
    setSubmitting(true);
    setError("");
    try {
      await api.post("/teams/invites/accept/", { token });
      setAccepted(true);
    } catch (requestError: unknown) {
      setError(
        apiErrorMessage(requestError, "De uitnodiging kon niet worden geaccepteerd."),
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="invite-page">
      <Seo
        title="Teamuitnodiging"
        path="/team-uitnodiging"
        description="Accepteer je teamuitnodiging."
        noIndex
      />
      <header>
        <BrandMark />
      </header>
      <main className="surface invite-panel">
        <span className={`invite-icon${accepted ? " accepted" : ""}`}>
          {accepted ? <CheckCircle2 size={28} /> : <UsersRound size={28} />}
        </span>
        <p className="eyebrow">Teamuitnodiging</p>
        <h1>{accepted ? "Je bent toegevoegd" : "Word lid van je team"}</h1>
        <p>
          {accepted
            ? "Je organisatie en teamplanning staan klaar in je werkruimte."
            : "Accepteer de uitnodiging met het account waarop je deze e-mail hebt ontvangen."}
        </p>
        {error && <ErrorNotice>{error}</ErrorNotice>}
        {accepted ? (
          <Link className="button primary" to="/app">
            <LogIn size={17} /> Naar DeVerlofkaart
          </Link>
        ) : (
          <button
            className="button primary"
            type="button"
            disabled={!token || submitting}
            onClick={() => void acceptInvite()}
          >
            <UsersRound size={17} />{" "}
            {submitting ? "Uitnodiging verwerken..." : "Uitnodiging accepteren"}
          </button>
        )}
      </main>
    </div>
  );
}
